import { computed, inject, Injectable, Signal } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IMenuGroup } from '@models/MenuGroup';
import { IconSanitizerService } from 'ngx-lib';
import { UserRoles } from '../models/enums/UserRoles';
import { UserOrganizationStorageService } from './user-organization-storage.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private readonly iconSanitizer = inject(IconSanitizerService);
    private readonly userOrganizationStorageService = inject(UserOrganizationStorageService);

    private _icons?: Record<string, SafeHtml>;

    private get icons(): Record<string, SafeHtml> {
        if (!this._icons) {
            this._icons = {
                dashboard: this.iconSanitizer.getIcon('dashboard'),
                opportunities: this.iconSanitizer.getIcon('opportunities'),
                contacts: this.iconSanitizer.getIcon('contacts'),
                buildings: this.iconSanitizer.getIcon('buildings'),
                companies: this.iconSanitizer.getIcon('companies'),
                accounts: this.iconSanitizer.getIcon('accounts'),
                reports: this.iconSanitizer.getIcon('reports'),
                configuration: this.iconSanitizer.getIcon('configuration')
            };
        }
        return this._icons;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    menu: Signal<IMenuGroup[]> = computed(() => {
        const selectedOrg = this.userOrganizationStorageService.getUserOrganization();
        const isFooterVisible = (selectedOrg?.roleId ?? 0) >= UserRoles.SalesAdmin;

        return [
            {
                id: 'General',
                name: '',
                isVisible: true,
                menuItems: [
                    {
                        id: 'Dashboard',
                        name: 'Dashboard',
                        icon: this.icons['dashboard'],
                        link: 'dashboard',
                        isVisible: true
                    },
                    {
                        id: 'Opportunities',
                        name: 'Opportunities',
                        icon: this.icons['opportunities'],
                        isVisible: true,
                        link: 'opportunities'
                    },
                    {
                        id: 'Contacts',
                        name: 'Contacts',
                        icon: this.icons['contacts'],
                        isVisible: true,
                        link: 'contacts'
                    },
                    {
                        id: 'Buildings',
                        name: 'Buildings',
                        icon: this.icons['buildings'],
                        isVisible: true,
                        link: 'buildings'
                    },
                    {
                        id: 'Companies',
                        name: 'Companies',
                        icon: this.icons['companies'],
                        isVisible: true,
                        link: 'companies'
                    },
                    {
                        id: 'Accounts',
                        name: 'Accounts',
                        icon: this.icons['accounts'],
                        isVisible: true,
                        link: 'accounts'
                    },
                    {
                        id: 'Reports',
                        name: 'Reports',
                        icon: this.icons['reports'],
                        isVisible: true,
                        link: 'reports'
                    }
                ]
            },
            {
                id: 'Footer',
                name: 'Footer',
                isFooter: true,
                isVisible: isFooterVisible,
                menuItems: [
                    {
                        id: 'Configuration',
                        name: 'Configuration',
                        icon: this.icons['configuration'],
                        isVisible: isFooterVisible,
                        link: 'configuration'
                    }
                ]
            }
        ];
    });
}
